import { Component } from '@angular/core'

@Component({
  template: '<ftr-confirmation-sent></ftr-confirmation-sent>',
  standalone: false,
})
export class ConfirmationSentPage {}
